// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__VRhfC","amount":"Amount_amount__2YngD","tip":"Amount_tip__2nMXR","tipHeader":"Amount_tipHeader__3XQd2","tipsWrap":"Amount_tipsWrap__3mamv"};